export default __webpack_public_path__ + "media/images/flags/me-fee2b464b56e9096fcbaa7b87e3dcb0b.png";